import { Star, MapPin, ArrowUpRight } from "lucide-react";

const GBP_URL =
  process.env.REACT_APP_GBP_URL ||
  "https://www.google.com/maps/search/?api=1&query=IVrenovation+Durham+Region+Ontario";

const MAP_SRC =
  process.env.REACT_APP_GBP_EMBED_URL ||
  `https://maps.google.com/maps?q=${encodeURIComponent(
    "IVrenovation Durham Region Ontario Canada"
  )}&output=embed`;

export const GoogleBusinessSection = () => {
  return (
    <section className="bg-white border-t border-zinc-200" data-testid="gbp-section">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-16 md:py-20 grid grid-cols-12 gap-8 items-center">
        <div className="col-span-12 md:col-span-5">
          <p className="overline">Find us on Google</p>
          <h3 className="font-display text-3xl md:text-4xl tracking-tighter text-zinc-950 mt-3">
            See our profile and reviews on Google.
          </h3>
          <p className="mt-4 text-zinc-600">
            We&apos;re listed on Google Maps and Google Business — read what
            homeowners across the Durham Region and GTA have to say, or leave a
            review after your project.
          </p>

          <div className="mt-6 flex items-center gap-2 text-orange-600" aria-label="5-star rating">
            <Star className="w-5 h-5 fill-orange-600" />
            <Star className="w-5 h-5 fill-orange-600" />
            <Star className="w-5 h-5 fill-orange-600" />
            <Star className="w-5 h-5 fill-orange-600" />
            <Star className="w-5 h-5 fill-orange-600" />
          </div>

          <div className="mt-6 flex flex-wrap gap-3">
            <a
              href={GBP_URL}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="gbp-view-button"
              className="bg-graphite hover:bg-orange-600 text-white px-6 py-3.5 text-sm font-bold uppercase tracking-wider inline-flex items-center gap-2 transition"
            >
              View on Google <ArrowUpRight className="w-4 h-4" />
            </a>
            <a
              href={GBP_URL}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="gbp-review-button"
              className="border border-zinc-300 hover:border-zinc-950 text-zinc-900 px-6 py-3.5 text-sm font-bold uppercase tracking-wider inline-flex items-center gap-2 transition"
            >
              Leave a review <Star className="w-4 h-4" />
            </a>
          </div>

          <p className="text-xs text-zinc-500 mt-6 flex items-center gap-2">
            <MapPin className="w-3.5 h-3.5" /> Durham Region &amp; GTA, Ontario
          </p>
        </div>

        <div className="col-span-12 md:col-span-7">
          <div className="aspect-[4/3] md:aspect-[16/10] border border-zinc-200 overflow-hidden">
            <iframe
              title="IVrenovation on Google Maps"
              src={MAP_SRC}
              width="100%"
              height="100%"
              style={{ border: 0 }}
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              data-testid="gbp-map-iframe"
            />
          </div>
        </div>
      </div>
    </section>
  );
};
